module.exports = __webpack_public_path__ + "media/images/redesign-images/misc/nav-image-04-c84d9ae5c8f0c192c39cf2105647b348.webp";